import { BrowserRouter, Route, Routes } from "react-router-dom";


import ErrorPage from "./pages/ErrorPage";
import SignInPage from "./pages/SignInPage";
import SignUpPage from "./pages/SignUpPage";

import RouteScrollToTop from "./helper/RouteScrollToTop";
import { NotificationContainer } from 'react-notifications';
import 'react-notifications/lib/notifications.css'; 
import MediaManagerPage from "./pages/MediaManagerPage";
import ChangePasswordPage from "./pages/ChangePasswordPage"
import ContactDetailsPage from "./pages/ContactDetailsPage";

function App() {
  return (
    <BrowserRouter>
      <RouteScrollToTop />
      <Routes>
        <Route exact path="/" element={<SignInPage />} /> {/*Signin Page */}
        <Route exact path="/media" element = {<MediaManagerPage/>} />
        <Route exact path="/contact-details" element = {<ContactDetailsPage/>} />
        <Route exact path ="/change-password" element = {<ChangePasswordPage/>} />
        <Route exact path="/sign-up" element={<SignUpPage />} />
        <Route exact path="*" element={<ErrorPage />} />
      </Routes>
      <NotificationContainer />
    </BrowserRouter>
  );
}

export default App;
